module.exports = __webpack_public_path__ + "static/media/GutHowItWorks1.5f50ea0b.png";